import { render } from "./CareerOverview.vue?vue&type=template&id=8f389030"
import script from "./CareerOverview.vue?vue&type=script&lang=ts"
export * from "./CareerOverview.vue?vue&type=script&lang=ts"

import "./CareerOverview.vue?vue&type=style&index=0&id=8f389030&lang=scss"
script.render = render

export default script